import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'iad-error403',
  templateUrl: './error403.component.html',
  styleUrls: ['./error403.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Error403Component {
}
